/**
* Created by vouill on 8/22/18.
*/

<template>
  <div :class="['v-global-content-container', {paddingTop: paddingTop}]">
    <slot/>
  </div>
</template>
<style scoped>
.v-global-content-container {
  max-width: 700px;
  padding: 1em;
  margin: auto;
}

.paddingTop {
  padding-top: 4em;
}
</style>
<script>
export default {
  name: "GlobalContentContainer",
  props: { paddingTop: Boolean }
};
</script>
